export function svMileageToKmMapper(_ref) {
  let {
    config,
    initialPayload
  } = _ref;
  const {
    locale
  } = config;
  return {
    carLead: {
      km: locale === 'sv-SE' ? scandinavianMileageToKm(initialPayload.carLead.km) : initialPayload.carLead.km
    }
  };
}
export function svLPMileageToKmMapper(_ref2) {
  let {
    config,
    initialPayload
  } = _ref2;
  const {
    locale
  } = config;
  return {
    mileage: locale === 'sv-SE' ? scandinavianMileageToKm(initialPayload.mileage) : initialPayload.mileage
  };
}
function scandinavianMileageToKm(mileage) {
  const SCANDINAVIAN_MILE_IN_KM = 10;
  const MAX_INT = 2 ** 31 - 1;
  const parsed = Number(mileage);
  if (Number.isNaN(parsed)) {
    return mileage;
  }
  return String(Math.min(MAX_INT, Math.round(parsed * SCANDINAVIAN_MILE_IN_KM)));
}